import { Component } from "react";
import _ from "lodash";

import Error404 from "../404";
import { Props } from "../propTypes";
import GroupsCollections from "./GroupsCollections";
import GroupsHome from "./GroupsHome";
import { Campus } from "../../store/main/types";
import { eGroupHome } from "../../store/egroups/types";
import { mapDispatchToProps, mapStateToProps } from "../../store/mapProps";
import { connect } from "react-redux";
import { withRouter, NextRouter } from "next/router";

interface WithRouterProps {
    router: NextRouter;
}
import EgroupCampusSelector from "./GroupCampusSelector";
import { ParsedUrlQuery } from "node:querystring";

type State = {
    campuses: Campus[];
    isLoading: boolean;
    eGroupHomeData: eGroupHome | undefined;
    show404: boolean;
    renderSection: string;
    processedUrl: string;
    processedQuery: ParsedUrlQuery;
    showChooseCampusType: boolean;
};

class eGroupRouter extends Component<Props & WithRouterProps, State> {
    eGroupBaseUrl = "/egroups";
    private collectionsUrlName = "collections";

    state: State = {
        campuses: [],
        isLoading: true,
        eGroupHomeData: undefined,
        show404: false,
        renderSection: "",
        processedUrl: "",
        showChooseCampusType: !this.props.router.query?.campusSelector,
        processedQuery: {},
    };

    componentDidMount() {
        if (window != undefined) {
            this.eGroupBaseUrl = window.location.pathname; //remove the params from the url
            this.props.actions.eGroups.egroupsGetHomeByUrl({
                url: window.location.pathname,
                disableCampusCheck:
                    process.env.NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR === "1",
            });

            let selectedCampusSlug = "";

            if (process.env.NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR !== "1") {
                if (_.isEmpty(this.props.main.campuses)) {
                    this.props.actions.main.main_get_all_campuses();
                } else {
                    selectedCampusSlug = this.getCampusSlug();
                }
            }

            this.setState({
                renderSection: this.getSection(),
                showChooseCampusType: !this.props.router.query?.campusSelector
                    ? !this.props.router.query?.campusSelector
                    : this.getCampusSlug() == "",
            });
        }
    }

    componentDidUpdate() {
        if (window != undefined) {
            if (!_.isEqual(this.props.main.campuses, this.state.campuses)) {
                this.setState({
                    campuses: this.props.main.campuses,
                    isLoading: !this.state.eGroupHomeData,
                    processedUrl: !_.isEmpty(this.props.eGroups.eGroupHomeData)
                        ? this.getCurrentUrl()
                        : "",
                    renderSection: this.getSection(),
                });
            }

            if (
                !_.isEqual(
                    this.props.eGroups.eGroupHomeData,
                    this.state.eGroupHomeData
                ) ||
                this.props.eGroups.eGroupHomeData?.loadTime !==
                    this.state.eGroupHomeData?.loadTime
            ) {
                if (!this.props.eGroups.eGroupHomeData?.loadError) {
                    this.setState({
                        eGroupHomeData: this.props.eGroups.eGroupHomeData,
                        isLoading:
                            process.env.NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR !==
                                "1" && this.props.main.campuses.length < 1,
                        processedUrl:
                            this.props.main.campuses.length > 0 ||
                            process.env.NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR ===
                                "1"
                                ? this.getCurrentUrl()
                                : "",
                    });
                } else {
                    this.setState({
                        show404: true,
                        isLoading:
                            process.env.NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR !==
                                "1" && this.props.main.campuses.length < 1,
                        eGroupHomeData: this.props.eGroups.eGroupHomeData,
                        processedUrl:
                            this.props.main.campuses.length > 0 ||
                            process.env.NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR ===
                                "1"
                                ? this.getCurrentUrl()
                                : "",
                    });
                }
            }

            if (
                (this.state.processedUrl !== this.getCurrentUrl() ||
                    !_.isEqual(
                        this.props.router.query,
                        this.state.processedQuery
                    )) &&
                !this.state.isLoading
            ) {
                this.setState(
                    {
                        renderSection: this.getSection(
                            this.getShowChooseCampusType(
                                this.props.router.query
                            )
                        ),
                        processedUrl:
                            this.props.main.campuses.length > 0 ||
                            process.env.NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR ===
                                "1"
                                ? this.getCurrentUrl()
                                : "",
                        show404: false,
                        showChooseCampusType: this.getShowChooseCampusType(
                            this.props.router.query
                        ),
                        processedQuery: _.cloneDeep(this.props.router.query),
                    },
                    () => {
                        const urlToTest = this.getCurrentUrlWithoutMeta();

                        if (
                            (this.props.eGroups.eGroupHomeData?.url &&
                                this.props.eGroups.eGroupHomeData?.url !==
                                    urlToTest) ||
                            !urlToTest ||
                            !this.props.eGroups.eGroupHomeData?.url
                        ) {
                            this.props.actions.eGroups.egroupsGetHomeByUrl({
                                url: window.location.pathname,
                                disableCampusCheck:
                                    process.env
                                        .NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR ===
                                    "1",
                            });
                        }
                    }
                );
            }
        }
    }

    getShowChooseCampusType(parsedQuerystring: ParsedUrlQuery) {
        let showTypeCampusSelector = parsedQuerystring.campusSelector
            ? false
            : this.getCampusSlug() === "";

        // if (
        //     !parsedQuerystring.campusSelector &&
        //     this.getCampusSlug() === "" &&
        //     !this.state.showCampusSelector
        // ) {
        //     showCampusSelector = true;
        // }

        if (
            parsedQuerystring.campusSelector &&
            this.getCampusSlug() === "" &&
            this.state.showChooseCampusType
        ) {
            showTypeCampusSelector = false;
        }

        return process.env.NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR == "1"
            ? false
            : showTypeCampusSelector;
    }

    getSection = (newShowCampusSelector?: boolean) => {
        let renderSection = "home";
        let showCampusSelector = this.state.showChooseCampusType;

        if (newShowCampusSelector !== undefined) {
            showCampusSelector = newShowCampusSelector;
        }

        const urlPieces = this.getCurrentUrl().split("/");

        if (
            (urlPieces[urlPieces.length - 1] &&
                urlPieces[urlPieces.length - 1] === this.collectionsUrlName) ||
            (urlPieces[urlPieces.length - 2] &&
                urlPieces[urlPieces.length - 2] === this.collectionsUrlName)
        ) {
            renderSection = this.collectionsUrlName;
        }

        if (
            this.getCampusSlug() === "" &&
            showCampusSelector &&
            renderSection != this.collectionsUrlName &&
            process.env.NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR !== "1"
        ) {
            renderSection = "campusSelector";
        }

        return renderSection;
    };

    getCampusSlug = (): string => {
        if (this.props.router?.query.campus) {
            const campus = this.props.router?.query.campus || "";
            if (
                campus.length > 0 &&
                campus[campus.length - 1] &&
                this.isValidCampus(campus[campus.length - 1])
            )
                return campus[0];
        } else {
            return "";
        }

        return "";
    };

    isValidCampus(query: string): Boolean {
        let found = false;
        if (
            this.props.main.campuses.length > 0 &&
            process.env.NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR !== "1"
        ) {
            this.props.main.campuses.forEach((campus) => {
                if (campus.slugName == query) {
                    found = true;
                }
            });
        }

        return found;
    }

    getCurrentUrl() {
        const urlParts = this.props.router.asPath.substr(1).split("?"); // remove initial "/" and remove the querystring
        let url = urlParts[0];

        if (url[url.length - 1] === "/") {
            url = url.slice(0, -1);
        }

        return url;
    }

    getCurrentUrlWithoutMeta() {
        let url = this.getCurrentUrl();

        if (this.getCampusSlug()) {
            url = url.replace("/" + this.getCampusSlug(), "");
        }

        url = url.replace("/collections", "");

        return url;
    }

    render() {
        if (this.state.show404) {
            return <Error404 />;
        }

        let selectedCampus = "";
        if (
            _.isArray(this.props.router?.query.campus) &&
            this.props.router?.query.campus.length > 0
        ) {
            selectedCampus =
                this.props.router?.query.campus[
                    this.props.router?.query.campus.length - 1
                ];
        } else if (
            !_.isArray(this.props.router?.query.campus) &&
            this.props.router?.query.campus
        ) {
            selectedCampus = this.props.router?.query.campus;
        }

        if (this.state.isLoading) {
            return null;
        } else {
            switch (this.state.renderSection) {
                case "collections":
                    return (
                        <GroupsCollections
                            selectedCampusSlug={selectedCampus}
                            url={this.state.processedUrl}
                            {...this.props}
                        />
                    );
                case "campusSelector":
                    return (
                        <EgroupCampusSelector
                            setShowCampusSelector={(
                                showChooseCampusType: boolean,
                                callback?: Function
                            ) => {
                                this.setState(
                                    {
                                        showChooseCampusType,
                                        // renderSection: "home",
                                    },
                                    () => {
                                        if (callback) {
                                            callback();
                                        }
                                    }
                                );
                            }}
                            eGroupBaseUrl={this.eGroupBaseUrl}
                            {...this.props}
                        />
                    );
                default:
                    return (
                        <GroupsHome
                            selectedCampusSlug={selectedCampus}
                            url={this.state.processedUrl}
                            {...this.props}
                        />
                    );
            }
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(eGroupRouter));
